export default {
  'measurement.tons': '{weight} tấn',
  'measurement.height': 'cao(m)',
  'measurement.length': 'dài(m)',
  'measurement.width': 'rộng(m)',
};
